









import { defineComponent } from '@vue/composition-api';
import { useUser }         from '@/views/users/hooks/use-user';
import cUserTile           from '@/views/users/components/view-mode/grid/components/user-tile.component.vue';

export default defineComponent({
  name: 'cUsersListGrid',
  components: {
    cUserTile,
  },
  setup() {
    const { users } = useUser();

    return {
      users,
    };
  },
});
